import asyncActionTypes from './types.js';

export const openModalLogin = ( response ) => ({
  type: asyncActionTypes.OPEN_MODAL_LOGIN.SUCCESS,
  payload: response,
});

export const modalLoginMethod = ( response ) => ({
  type: asyncActionTypes.OPEN_MODAL_LOGIN_METHOD.SUCCESS,
  payload: response,
});

export function setOpenModalLogin(options) {
  return function action(dispatch) {
    dispatch(openModalLogin(options));
  };
}

export function setModalLoginMethod(options) {
  return function action(dispatch) {
    dispatch(modalLoginMethod(options));
  };
}